export const TABLE_HEADING_TYPE = 'heading';
